import React, { useEffect } from "react";
// @ts-ignore
import AccountMenuLink from "@fdr/atomic-ui/_molecules/AccountMenuLink";
import { breakpoints, useMediaQuery } from "@tvg/design-system";
import {
  StateSelectorWrapper,
  Title,
  Description,
  MenuItemsGroup,
  MenuItem,
  StateSelectorBackground
} from "./styled-components";
import { Props } from "./types";

export const StateSelector = ({
  qaLabel = "state-selector",
  title,
  description,
  states,
  onSelectState,
  to
}: Props) => {
  const isDesktop = useMediaQuery(breakpoints.desktop.min.lg);

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "unset";
    };
  }, []);

  return (
    <StateSelectorBackground isDesktop={isDesktop}>
      <StateSelectorWrapper data-qa-label={qaLabel} isDesktop={isDesktop}>
        <Title data-qa-label={`${qaLabel}-title`}>{title}</Title>
        <Description data-qa-label={`${qaLabel}-description`}>
          {description}
        </Description>
        <MenuItemsGroup data-qa-label={`${qaLabel}-items-group`}>
          {states.map((state) => (
            <MenuItem key={state.abbreviation}>
              <AccountMenuLink
                qaLabel={`${qaLabel}-item-${state.abbreviation}`}
                onClick={() => onSelectState && onSelectState(state)}
                linkText={state.name}
                hideLeftIcon
                to={to}
              />
            </MenuItem>
          ))}
        </MenuItemsGroup>
      </StateSelectorWrapper>
    </StateSelectorBackground>
  );
};

export default StateSelector;
